import { render, staticRenderFns } from "./AlimentosForm.vue?vue&type=template&id=386029c0&scoped=true&lang=pug"
import script from "./AlimentosForm.vue?vue&type=script&lang=js"
export * from "./AlimentosForm.vue?vue&type=script&lang=js"
import style0 from "./AlimentosForm.styl?vue&type=style&index=0&id=386029c0&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386029c0",
  null
  
)

export default component.exports